import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PublicHeader from "../../Common/Layout/PublicHeader";
import Footer from "../../Common/Layout/Footer";
const initialFieldValues = {
    applicationLenderId: "00000000-0000-0000-0000-000000000000",
    lendingApplicationId: "00000000-0000-0000-0000-000000000000",
    lenderId: "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    description: "",
    companyName: "",
    contactName: "",
    email: "",
    phoneNumber: "",
    status: "",
    amount: 0,
    reason: "",
    loanAmount: 0,
    rate: 0,
    paybackAmount: 0,
    paymentAmount: 0,
    paymentFrequency: "DAILY",
    numberOfPayments: 0,
    commissionPoints: 0,
    commission: 0,
    domainurl: window.location.origin,
    conditions: ""
};
export default function ApproveApplication() {
    const navigate = useNavigate();
    const [values, setValues] = useState(initialFieldValues);
    const [loading, setLoading] = useState(false);
    const [lendingApplication, setLendingApplication] = useState({});
    const [errors, setErrors] = useState({});
    const [lenderId, setLenderId] = useState("00000000-0000-0000-0000-000000000000");
    const [lendingApplicationId, setLendingApplicationId] = useState("00000000-0000-0000-0000-000000000000");
    const [searchParams, setSearchParams] = useSearchParams();
    const [advanceAmount, setAdvanceAmount] = useState(0);
    const [factorRate, setFactorRate] = useState(0);
    const [paybackAmount, setPaybackAmount] = useState(0);
    const [numberOfPayments, setNumberOfPayments] = useState(0);
    const [paymentAmount, setPaymentAmount] = useState(0);
    const [commissionPoints, setCommissionPoints] = useState(0);
    const [commission, setCommission] = useState(0);
    const handleAdvanceAmount = (e) => {
        if (e.target.value > 0) {
            let AAAmount = parseFloat(e.target.value);
            setAdvanceAmount(AAAmount);
            let FRAmount = parseFloat(factorRate);
            setFactorRate(FRAmount);
            setPaybackAmount(AAAmount * FRAmount);

            if (commissionPoints > 0) {
                const commissionValue = Math.round((AAAmount * commissionPoints) / 100);
                setCommission(commissionValue);
            }
        }
        else {
            setAdvanceAmount(0);
            setCommission(0);
        }
    };
    const handleFactorAmount = (e) => {
        if (e.target.value > 0) {
            let FRAmount = parseFloat(e.target.value);
            setFactorRate(FRAmount);
            let AAAmount = parseFloat(advanceAmount);
            setAdvanceAmount(AAAmount);
            setPaybackAmount(Math.round(AAAmount * FRAmount));
        }
    };
    const handleNumberOfPayments = (e) => {
        if (e.target.value > 0) {
            let NPayments = parseFloat(e.target.value);
            setNumberOfPayments(NPayments);
            if (paybackAmount > 0) {
                setPaymentAmount(Math.round(paybackAmount / NPayments));
            }
        }
    };
    const handleCommissionChange = (e) => {
        const CPoints = parseFloat(e.target.value);
        if (CPoints > 0) {
            setCommissionPoints(CPoints);
            const commissionValue = Math.round((advanceAmount * CPoints) / 100);
            setCommission(commissionValue);
        }
        else {
            setCommissionPoints(CPoints);
            setCommission(0);
        }
    };

    const GetApplication = (lendingApplicationId, lenderId) => {
        axios
            .get(config.APIACTIVATEURL + config.GETAPPLICATIONLENDERBYLENDER + "?LendingApplicationId=" + lendingApplicationId + "&LenderId=" + lenderId, { ...headerconfig })
            .then((response) => {
                console.log(response.data.data);
                if (response.data.statusCode === 200) {
                    setLendingApplication(response.data.data);
                }
                else {
                    setValues(initialFieldValues);
                }
            });
    }
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };
    const validate = () => {
        let temp = {};
        temp.advanceAmount = advanceAmount === 0 ? false : true;
        temp.factorRate = factorRate === 0 ? false : true;
        temp.paybackAmount = paybackAmount === 0 ? false : true;
        temp.paymentAmount = paymentAmount === 0 ? false : true;
        temp.commissionPoints = commissionPoints === 0 ? false : true;
        temp.numberOfPayments = numberOfPayments === 0 ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            setLoading(true);
            var formData = new FormData()
            formData.append("lendingApplicationId", lendingApplicationId);
            formData.append("lenderId", lenderId);
            formData.append("userId", lendingApplication.userId);
            formData.append("clientId", lendingApplication.clientId);
            formData.append("status", "APPROVED");
            formData.append("loanAmount", advanceAmount);
            formData.append("rate", factorRate);
            formData.append("paybackAmount", paybackAmount);
            formData.append("paymentAmount", paymentAmount);
            formData.append("paymentFrequency", values.paymentFrequency);
            formData.append("numberOfPayments", numberOfPayments);
            formData.append("commissionPoints", commissionPoints);
            formData.append("commission", commission);
            formData.append("reason", values.reason);
            formData.append("conditions", values.conditions);
            addOrEdit(formData);
        }
    };
    const applicationAPI = () => {
        return {
            update: (newrecord) => axios.put(config.APIACTIVATEURL + config.UPDATEAPPLICATIONLENDER, newrecord, { ...headerconfig })
        };
    };
    const addOrEdit = (formData) => {
        applicationAPI().update(formData)
            .then((res) => {
                if (res.data.statusCode === 200) {
                    handleSuccess("Application status successfully submitted");
                    resetForm();
                    setLoading(false);
                    GetApplication(lendingApplicationId, lenderId);
                }
                else {
                    handleError(res.data.message);
                    setLoading(false);
                }
            })
            .catch(function (error) {
                handleError("Error in updating data");
                setLoading(false);
            });
    };
    const resetForm = () => {
        setValues(initialFieldValues);
    };
    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        if (searchParams === null) {
            navigate('/')
        }
        else {
            setLendingApplicationId(searchParams.get("applicationId"))
            var letparams = searchParams.toString();
            var splitparams = letparams.split('=')
            setLenderId(splitparams[2]);
            GetApplication(searchParams.get("applicationId"), splitparams[2]);
        }
    }, [])
    return (
        <div id="layout-wrapper">
            <PublicHeader></PublicHeader>
            <div className="body-wrapper" style={{ marginTop: "-20px" }}>
                {lendingApplication.status === "APPROVED" ?
                    <div className="container-fluid"><div className="badge text-bg-success"> Thankyou, Your response already <b>submitted</b></div></div> :
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Application</h5>
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <label htmlFor="reason" className="form-label">Business Name : {lendingApplication.businessName}</label>
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label htmlFor="reason" className="form-label">Amount Requested : $ {lendingApplication.amount}</label>
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label htmlFor="reason" className="form-label">Funds Required For : {lendingApplication.description}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-3 mb-3">
                                            <label htmlFor="loanAmount" className="form-label">Advance Amount($)</label>
                                            <input type="number" value={advanceAmount} name="advanceAmount" onChange={handleAdvanceAmount} className={"form-control" + applyErrorClass('advanceAmount')} placeholder="20000" />
                                            {errors.advanceAmount === false ? (<div className="validationerror">Please enter advanceAmount </div>) : ('')}
                                        </div>
                                        <div className="col-lg-3 mb-3">
                                            <label htmlFor="rate" className="form-label">Factor Rate</label>
                                            <input type="number" value={factorRate} name="factorRate" onChange={handleFactorAmount} className={"form-control" + applyErrorClass('factorRate')} placeholder="2.10" />
                                            {errors.factorRate === false ? (<div className="validationerror">Please enter rate </div>) : ('')}
                                        </div>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-3 mb-3">
                                            <label htmlFor="paymentFrequency" className="form-label">Payment Frequency</label>
                                            <select onChange={handleInputChange} value={values.paymentFrequency} name="paymentFrequency" className={"form-select" + applyErrorClass('paymentFrequency')}>
                                                <option value="DAILY">DAILY</option>
                                                <option value="WEEKLY">WEEKLY</option>
                                                <option value="MONTHLY">MONTHLY</option>
                                                <option value="YEARLY">YEARLY</option>
                                            </select>
                                            {errors.paymentFrequency === false ? (<div className="validationerror">Please enter paymentFrequency </div>) : ('')}
                                        </div>
                                        <div className="col-lg-3 mb-3">
                                            <label htmlFor="numberOfPayments" className="form-label">Number of Payments</label>
                                            <input type="number" value={numberOfPayments} name="numberOfPayments" onChange={handleNumberOfPayments} className={"form-control" + applyErrorClass('numberOfPayments')} placeholder="100" />
                                            {errors.numberOfPayments === false ? (<div className="validationerror">Please enter numberOfPayments </div>) : ('')}
                                        </div>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-3 mb-3">
                                            <label htmlFor="paybackAmount" className="form-label">Payback Amount($)</label>
                                            <input type="number" value={paybackAmount} name="paybackAmount" onChange={handleInputChange} className={"form-control" + applyErrorClass('paybackAmount')} placeholder="25000" />
                                            {errors.paybackAmount === false ? (<div className="validationerror">Please enter payback amount </div>) : ('')}
                                        </div>
                                        <div className="col-lg-3 mb-3">
                                            <label htmlFor="paymentAmount" className="form-label">Payment Amount($)</label>
                                            <input type="number" value={paymentAmount} name="paymentAmount" onChange={handleInputChange} className={"form-control" + applyErrorClass('paymentAmount')} placeholder="0" />
                                            {errors.paymentAmount === false ? (<div className="validationerror">Please enter payment amount </div>) : ('')}
                                        </div>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-3 mb-3">
                                            <label htmlFor="commissionPoints" className="form-label">Max Commission Points</label>
                                            <input type="number" value={commissionPoints} name="commissionPoints" onChange={handleCommissionChange} className={"form-control" + applyErrorClass('commissionPoints')} placeholder="0" />
                                            {errors.commissionPoints === false ? (<div className="validationerror">Please enter commissionPoints </div>) : ('')}
                                        </div>
                                        <div className="col-lg-3 mb-3">
                                            <label htmlFor="commission" className="form-label">Max Commission($)</label>
                                            <input type="number" value={commission} name="commission" onChange={handleInputChange} className={"form-control" + applyErrorClass('commission')} placeholder="0" />
                                            {errors.commission === false ? (<div className="validationerror">Please enter commission </div>) : ('')}
                                        </div>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-6 mb-3">
                                            <label htmlFor="conditions" className="form-label">Conditions</label>
                                            <input type="text" value={values.conditions} name="conditions" onChange={handleInputChange} className={"form-control" + applyErrorClass('conditions')} placeholder="Please enter conditions,If any..." />
                                            {errors.conditions === false ? (<div className="validationerror">Please enter conditions </div>) : ('')}
                                        </div>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-3 mb-3">
                                            <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                                {loading === false ?
                                                    <button type="submit" className="btn btn-success">Approve</button>
                                                    :
                                                    <button type="button" className="btn btn-info" disabled>Loading, Please wait...</button>}
                                                <button type="button" className="btn btn-primary" onClick={resetForm}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <Footer></Footer>
        </div>
    );
}